
<div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="start center" [innerHTML]="setDetails">
</div>

